const TemplatePermissions = {
  edit: 'template:edit',
  create: 'template:create',
  delete: 'template:delete',
  view: 'template:view',
}

export default TemplatePermissions
